import { combineReducers, configureStore } from '@reduxjs/toolkit';

import auddReducer from '#reducers/audd/auddSlice';
import configSlice from '#reducers/config/config';

export const rootReducer = combineReducers({
  audd: auddReducer,
  config: configSlice,
});

export const setupStore = () => {
  return configureStore({
    reducer: rootReducer,
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
